import mixpanel from 'mixpanel-browser';
mixpanel.init("5f3ee5f4c14c0b4d94bb3e8b852075af");

const startTracking = () => {
    console.log("start tracking");
  };

const getMixpanelTrackingStatus = () => {
  try {
    if (mixpanel.has_opted_in_tracking()) {
      startTracking();
      return true;
    }
    else {
      return false;
    }
  } catch (error) {
    console.log(`Error calling mixpanel api: ${error}`);
    return false;
  }
};

const allowCookies = () => {
  try {
    mixpanel.opt_in_tracking(true);
    startTracking();
    return true;
  } 
  catch (error) {
    console.log(`Error calling mixpanel api: ${error}`);
    return false;
  }
};

const identifyUser = (user_id, allowance) => {
  if (!allowance) return false;
  if (!user_id) return false;
  try {
      if (mixpanel.identify(user_id)) {
        return true;
      }
      else {
        return false;
      }
  } catch (error) {
    console.log(`Error calling mixpanel api: ${error}`);
    return false;
  }
};

const trackAction = (action, allowance) => {
  if (!allowance) return false;
  try {
    mixpanel.track(action);
    return true;
  } catch (error) {
    console.log(`Error calling mixpanel api: ${error}`);
    return false;
  }
};

const termsConditionsURL = `${window.location.origin}/terms_conditions#privacy-policy`;

export {
  startTracking,
  getMixpanelTrackingStatus,
  allowCookies,
  identifyUser,
  trackAction,
  termsConditionsURL,
}
